import React, { useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { getOwnerMenuItems } from '../../components/layout/OwnerMenuConfig';
import Overview from '../owner/analytics/Overview';
import { 
  DashboardContainer, 
  DashboardHeader,
} from './Dashboard.styles';

const OwnerDashboard = () => {
  const menuItems = getOwnerMenuItems();
  
  // Get default date range (last 30 days)
  const getDefaultStartDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date.toISOString().split('T')[0];
  };
  
  const [startDate] = useState(getDefaultStartDate());
  const [endDate] = useState(new Date().toISOString().split('T')[0]);

  return (
    <DashboardLayout menuItems={menuItems}>
      <DashboardContainer>
        <DashboardHeader>
          <div>
            <h1>Owner Dashboard 👑</h1>
            <p>Platform overview and business intelligence</p>
          </div>
        </DashboardHeader>

        <Overview startDate={startDate} endDate={endDate} />
      </DashboardContainer>
    </DashboardLayout>
  );
};

export default OwnerDashboard;
